import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { disabledBlockSx } from "../disabledStyles";
import { Box, Button, IconButton } from "@mui/material";
import { TitleSubTitle } from "@platformx/utilities";
import { useEffect, useState } from "react";
import SelectPageList from "./SelectPageList";

const PagePicker = ({ state, setState, field, isDisabled = false }: any) => {
  const [openPage, setOpenPage] = useState(false);
  const [selectedPage, setSelectedPage] = useState<any>(null);

  const onSelectPage = (page) => {
    setSelectedPage(page);
  };

  const handleBackPage = () => {
    setOpenPage(false);
    setSelectedPage(state?.[field.name] || null);
  };

  const onClickPageDone = () => {
    setOpenPage(false);
    setState({
      ...state,
      [field.name]: selectedPage,
    });
  };

  const onOpenPage = () => {
    setOpenPage(true);
  };

  const onClearPage = () => {
    setSelectedPage(null);
    setState({
      ...state,
      [field.name]: "",
    });
  };

  useEffect(() => {
    const value = state?.[field.name];
    // Only a real page object is a valid selection. Guard against the empty
    // string / empty array that RadioCustomOptions re-seeds dependent fields
    // with on a radio switch, which otherwise renders an empty (title-less) box.
    if (value && typeof value === "object" && !Array.isArray(value)) {
      setSelectedPage(value);
    } else {
      setSelectedPage(null);
    }
  }, [state, field.name]);

  return (
    <Box sx={disabledBlockSx(isDisabled)}>
      {selectedPage ? (
        <Box
          className='category-container'
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            border: "solid 1px #ced3d9",
            borderRadius: "5px",
            padding: "13px 14px",
            width: "100%",
            marginTop: "12px",
            marginBottom: "15px",
          }}>
          <Box
            sx={{
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}>
            <TitleSubTitle
              subTitle={selectedPage?.Title}
              titleVariant='p4regular'
              subTitleVariant='h6regular'
            />
          </Box>
          <IconButton
            onClick={onClearPage}
            data-testid='clear-page'
            aria-label={selectedPage?.Title ? `Remove ${selectedPage.Title}` : "Remove"}
            sx={{ width: "32px", height: "32px" }}>
            <CloseOutlinedIcon sx={{ color: "#6e7191" }} />
          </IconButton>
        </Box>
      ) : null}

      <Button variant='primaryButton' onClick={onOpenPage}>
        {field?.title || "Choose Page"}
      </Button>

      {openPage ? (
        <SelectPageList
          handleBack={handleBackPage}
          selectedPage={selectedPage}
          onClickDone={onClickPageDone}
          onSelectPage={onSelectPage}
        />
      ) : null}
    </Box>
  );
};

export default PagePicker;
